import './pages.css';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { actionTypes } from './../../store';
import InputMask from 'react-input-mask';
import axios from "axios";
import { validationCpf, validationEmail } from "../../validations.js";
import { differenceInYears, parseISO } from 'date-fns';
import parse from 'html-react-parser';


export default function HereditaryRisk({changePage}){
    const data = useSelector((state) => state.data?.hereditaryRisk);
    const dispatch = useDispatch();
    const states = useSelector((state) => state.states);
    const [showFullText, setShowFullText] = useState(false);
    const baseData = {
          "nome_completo": "",
          "data_de_nascimento": "",
          "medico_solicitante": "",
          "ancestralidade_europeia_oriental_norte_europeu": "",
          "ancestralidade_africana": "",
          "ancestralidade_asiatica": "",
          "ancestralidade_ashkenazi": "",
          "ancestralidade_europa_central_leste_europeu": "",
          "ancestralidade_america_latina_caribe": "",
          "ancestralidade_indigena_especificar": "",
          "ancestralidade_indigena_especificar_desc": "",
          "ancestralidade_outra": "",
          "ancestralidade_outra_desc": "",
          "sem_historia_pessoal_de_cancer": "",
          "mama_invasivo": "",
          "idade_ao_diagnostico_invasivo": "",
          "tipo_invasivo_bilateral": "",
          "tipo_invasivo_pre_menopausal": "",
          "tipo_invasivo_triplo_negativo": "",
          "mama_in_situ": "",
          "idade_ao_diagnostico_in_situ": "",
          "tipo_in_situ_bilateral": "",
          "tipo_in_situ_pre_menopausal": "",
          "tipo_in_situ_triplo_negativo": "",
          "leucemia": "",
          "leucemia_age": "",
          "ovario": "",
          "ovario_age": "",
          "pulmao": "",
          "idade_ao_diagnostico_pulmao": "",
          "intestino": "",
          "intestino_age": "",
          "prostata": "",
          "prostata_age": "",
          "tipo_pulmao_pequenas_celulas": "",
          "tipo_pulmao_tabagista": "",
          "outro": "",
          "outro_desc": "",
          "outro_age": "",
          "sem_historia_familiar_de_cancer": "",
          "parentesco1": "",
          "materno1": "",
          "paterno1": "",
          "local_do_cancer1": "",
          "idade_ao_diagnostico1": "",
          "parentesco2": "",
          "materno2": "",
          "paterno2": "",
          "local_do_cancer2": "",
          "idade_ao_diagnostico2": "",
          "parentesco3": "",
          "materno3": "",
          "paterno3": "",
          "local_do_cancer3": "",
          "idade_ao_diagnostico3": "",
          "parentesco4": "",
          "materno4": "",
          "paterno4": "",
          "local_do_cancer4": "",
          "idade_ao_diagnostico4": "",
          "parentesco5": "",
          "materno5": "",
          "paterno5": "",
          "local_do_cancer5": "",
          "idade_ao_diagnostico5": ""
        }

    const [currentData, setCurrentData] = useState({...baseData,"cancer_history":false,
        "cancer_family_items":[{id:"1",'parentesco1': "","materno1":false,"paterno1":false, "local_do_cancer1":"",
            "idade_do_diagnóstico":""}],...data})


    const [items, setItems] = useState([
        {id:"general_information",title: "Informações Gerais (obrigatório)", type:"b"},
        {id:'nome_completo', text: 'Nome completo', type:'input', class:'col-xs-12 col-lg-12'},
        {id:'data_de_nascimento', text: 'Data de Nascimento', type:'input', props: {type: 'date'}, class:'col-xs-12 col-lg-4'},
        {id:'medico_solicitante', text: 'Médico Solicitante', type:'input', class:'col-xs-12 col-lg-4'},
        {id:'ancestralidade', text: 'Ancestralidade', type:"listCheck",class:"col-xs-12  col-lg-12",
            options:[{ id: 'europeia_oriental_norte_europeu', name: 'Européia Oriental/Norte Europeu' },
                        { id: 'europa_central_leste_europeu', name: 'Europa Central/Leste Europeu' },
                        { id: 'africana', name: 'Africana' },
                        { id: 'asiatica', name: 'Asiática' },
                        { id: 'ashkenazi', name: 'Ashkenazi' },
                        { id: 'america_latina_caribe', name: 'América Latina/Caribe' },
                        { id: 'indigena_especificar', name: 'Indígena. Especificar',input:true },
                        { id: 'outra', name: 'Outra',input:true }]},
        {id:"personal_history",title: "História Pessoal de Câncer", type:"b"},
        {id:'sem_historia_pessoal_de_cancer', text: '',name:'Sem história pessoal de câncer', type:'checkbox',class:"col-xs-12  col-lg-12"},
        {id:'hr1',text:'', type:'hr', show:[{key:"sem_historia_pessoal_de_cancer",value:false}]},
        {id:'mama_invasivo', text: '',name:'Mama, invasivo.', type:'checkbox', show:[{key:"sem_historia_pessoal_de_cancer",value:false}],class:"col-xs-12  col-lg-12"},
        {id:'idade_ao_diagnostico_invasivo', text: 'Idade ao diagnóstico', type:'input', placeholder:"",
            show:[{key:"mama_invasivo",value:true},{key:"sem_historia_pessoal_de_cancer",value:false}], class:"col-xs-12  col-lg-3"},
        {id:'tipo_invasivo', text: 'Tipo',  type:"radio",class:"col-xs-12  col-lg-9",
            show:[{key:"mama_invasivo",value:true},{key:"sem_historia_pessoal_de_cancer",value:false}],
            options:[{ id: 'bilateral', name: 'Bilateral'},
                        { id: 'pre_menopausal', name: 'Pré-menopausal'},
                        { id: 'triplo_negativo', name: 'Triplo-negativo'}
                        ]},
        {id:'hr2',text:'', type:'hr', show:[{key:"sem_historia_pessoal_de_cancer",value:false}]},
        {id:'mama_in_situ', text: '',name:'Mama, <i>In situ</i>.', type:'checkbox',
            show:[{key:"sem_historia_pessoal_de_cancer",value:false}],class:"col-xs-12  col-lg-12"},
        {id:'idade_ao_diagnostico_in_situ', text: 'Idade ao diagnóstico', type:'input', placeholder:"",
            show:[{key:"mama_in_situ",value:true},{key:"sem_historia_pessoal_de_cancer",value:false}], class:"col-xs-12  col-lg-3"},
        {id:'tipo_in_situ', text: 'Tipo',  type:"radio",class:"col-xs-12  col-lg-9",
            show:[{key:"mama_in_situ",value:true},{key:"sem_historia_pessoal_de_cancer",value:false}],
            options:[{ id: 'bilateral', name: 'Bilateral'},
                        { id: 'pre_menopausal', name: 'Pré-menopausal'},
                        { id: 'triplo_negativo', name: 'Triplo-negativo'}
                        ]},
        {id:'hr3',text:'', type:'hr', show:[{key:"sem_historia_pessoal_de_cancer",value:false}]},
        {id:'leucemia', text: '',name:'Leucemia', type:'checkbox', input:true,tag:"age", placeholder:"Idade ao diagnóstico",
            show:[{key:"sem_historia_pessoal_de_cancer",value:false}],class:"col-xs-12  col-lg-4"},
        {id:'ovario', text: '',name:'Ovário', type:'checkbox', input:true,tag:"age", placeholder:"Idade ao diagnóstico",
            show:[{key:"sem_historia_pessoal_de_cancer",value:false}],class:"col-xs-12  col-lg-4"},
        {id:'intestino', text: '',name:'Intestino', type:'checkbox', input:true,tag:"age", placeholder:"Idade ao diagnóstico",
            show:[{key:"sem_historia_pessoal_de_cancer",value:false}],class:"col-xs-12  col-lg-4"},
        {id:'prostata', text: '',name:'Próstata', type:'checkbox', input:true,tag:"age", placeholder:"Idade ao diagnóstico",
            show:[{key:"sem_historia_pessoal_de_cancer",value:false}],class:"col-xs-12  col-lg-4"},
        {id:'outro', text: '',name:'Outro:', type:'checkbox', input:true,tag:"desc", placeholder:"",
            show:[{key:"sem_historia_pessoal_de_cancer",value:false}],class:"col-xs-12  col-lg-4"},
        {id:'outro_age', text: '', type:'input', placeholder:"Idade ao diagnóstico",
            show:[{key:"outro",value:true},{key:"sem_historia_pessoal_de_cancer",value:false}], class:"col-xs-12  col-lg-3"},
        {id:'hr4',text:'', type:'hr', show:[{key:"sem_historia_pessoal_de_cancer",value:false}]},
        {id:'pulmao', text: '',name:'Pulmão', type:'checkbox', show:[{key:"sem_historia_pessoal_de_cancer",value:false}],class:"col-xs-12  col-lg-12"},
        {id:'idade_ao_diagnostico_pulmao', text: 'Idade ao diagnóstico', type:'input', placeholder:"",
            show:[{key:"pulmao",value:true},{key:"sem_historia_pessoal_de_cancer",value:false}], class:"col-xs-12  col-lg-3"},
        {id:'tipo_pulmao', text: 'Tipo',  type:"radio",class:"col-xs-12  col-lg-5",
            show:[{key:"pulmao",value:true},{key:"sem_historia_pessoal_de_cancer",value:false}],
            options:[{ id: 'pequenas_celulas', name: 'Pequenas-células'},
                        { id: 'tabagista', name: 'Tabagista'}
                        ]},
        {id:"historia_familiar_de_cancer",title: "História Familiar de Câncer", type:"b"},
        {id:'sem_historia_familiar_de_cancer', text: '',name:'Sem história familiar de câncer', type:'checkbox',class:"col-xs-12  col-lg-12"},

    ]);
    const items2 = [{id:'parentesco', text: 'Parentesco', type:'input', class:'col-xs-12 col-lg-4'},
                    {id:'materno', text: 'Materno',name:'', type:'checkbox',class:"col-xs-12  col-lg-1"},
                    {id:'paterno', text: 'Paterno',name:'', type:'checkbox',class:"col-xs-12  col-lg-1"},
                    {id:'local_do_cancer', text: 'Local do cancer', type:'input', class:'col-xs-12 col-lg-4'},
                    {id:'idade_do_diagnostico', text: 'Idade do diagnóstico', type:'input', class:'col-xs-12 col-lg-2'},
                    {id:'hr1-1',text:'', type:'hr'}]
    const handleSubmit = (event) => {
        event.preventDefault();
        var eventName = event.nativeEvent.submitter.name;
        if (eventName === "finish"){
            var hasError = false;
            var fields = ['nome_completo','data_de_nascimento','medico_solicitante','ancestralidade']
            if(currentData.sem_historia_pessoal_de_cancer !== true){
                var fields2 = ['mama_invasivo','mama_in_situ','leucemia','ovario','intestino','prostata','outro','pulmao']
                var find = fields2.some((f) => (f in currentData && currentData[f] === true))
                if(!find){
                    fields = [...fields,'personal_history']
                }
            }
            if(currentData.sem_historia_familiar_de_cancer !== true){
                if( currentData['parentesco1']?.lenght <3 || (currentData['materno1'] !== true && currentData['paterno1'] != true)){
                    fields = [...fields,'historia_familiar_de_cancer']
                }
            }
            fields.forEach((f) => {
                if(!(f in currentData) || currentData[f] == "" || currentData[f] == null){
                    setError(f,'Campo Obrigatório')
                    hasError = true;
                }
                else{
                    setError(f, null);
                }
            })
            if(!hasError){
                changePage(eventName)
            }
        }
        else{
                changePage(eventName)
        }
    }
    const setValue = (id, value, listCheck = false) => {
        setError(id, null);
        console.log(id)
        console.log(value)
        if(id === 'full_name'){
            setError(id, value?.length < 5? true:false, "incomplete");
        }
        var cancerH = ['sem_historia_pessoal_de_cancer','mama_invasivo','mama_in_situ','leucemia','ovario','intestino','prostata','outro','pulmao'];
        var cancerF = ['sem_historia_familiar_de_cancer','parentesco1', 'materno1', 'paterno1', 'local_do_cancer1', 'idade_do_diagnostico1'];
        if(cancerH.includes(id)){
            setError('personal_history', null)
        }
        if(cancerF.includes(id)){
            setError('historia_familiar_de_cancer', null)
        }
        setCurrentData((actualData) => {
            if(listCheck === true){
                if(id in actualData){
                    const index = actualData[id].indexOf(value);
                    value = index === -1? [...actualData[id], value]: actualData[id].filter(item => item !== value);
                }
                else{
                    value = [value]
                }
            }
            return ({...actualData, [id]:value});
        })
    }
    //Marca o status de erro e a mensagem de um campo
    function setError(id,value,key="error"){
          setItems((currentItens) => currentItens.map((i) => {
            if(i.id === id ){
                return {...i, [key]: value}
            }
            return i
          }))
    }
    function addNewLine(){

        setCurrentData((c) => {
            var newId = c.cancer_family_items.length
            var newItem = {[`parentesco${newId + 1}`]: "",
                        [`materno${newId + 1}`]:false,
                        [`paterno${newId + 1}`]:false,
                        [`local_do_cancer${newId + 1}`]:"",
                        [`idade_do_diagnóstico${newId + 1}`]:""};
            if(newId < 5){
                return ({...c,cancer_family_items:[...c.cancer_family_items,{...newItem,id:newId + 1} ]})
            }
            else{
                return c
            }
        })
    }
    useEffect(()=>{
        if(currentData){
            dispatch({ type: actionTypes.set_data, 'payload': {"hereditaryRisk":currentData}});
        }
    },[currentData])
    const getItem = (i, d) => {
        switch (i.type) {
            case "b":
                return (
                 <b id={i.id} className="subtitle">{i.title}</b>
                )
            case "input":
                return (
                    <InputMask key={i.id} id={i.id} name={i.id} type="text" placeholder={i.placeholder} title=""
                        value={d && d[i.id]} autoComplete="off" {...i.props} disabled={i.disabled === true}
                        onChange={(event) => setValue(i.id, event.target.value)}  mask={i.mask}
                        className={i.error ? 'border-danger' : ''} />
                );
            case "checkbox":
                return (
                    <label key={i.id} className="label-input label-radio d-flex">
                        <input id={i.id} className="checkInput" type="checkbox" name={i.id}
                            checked={d && d[i.id] } onChange={(event) => setValue(i.id, event.target.checked)} />
                        <b>{parse(i.name)}</b>
                        {(i.input === true && d[i.id] === true) &&
                                    <InputMask key={`input_${i.id}`} id={`input_${i.id}`} name={`input_${i.id}`}
                                        type="text" value={d && d[`${i.id}_${i.tag}`]} autoComplete="off"
                                        placeholder={i.placeholder}
                                        onChange={(event) => setValue(`${i.id}_${i.tag}`, event.target.value)}
                                        className={i.error ? 'border-danger' : ''} />
                                }
                    </label>
                );
            case "select":
                return (
                    <select key={i.id} id={i.id} name={i.id} onChange={(event) => setValue(i.id, event.target.value)}>
                        {i.options?.map((o) => (
                            <option key={o.id} value={o.id}>
                                {parse(o.name)}
                            </option>
                        ))}
                    </select>
                );
            case "radio":
                return (
                    <div key={i.id} id={i.id} className="d-flex div-radio">
                        {i.options?.map((o) => (
                            <label key={o.id} className="label-input label-radio d-flex">
                                <input id={o.id} className="radioInput" type="radio" name={i.id}
                                    checked={d && d[i.id] === o.id}
                                    onChange={(event) => setValue(i.id, event.target.id)} />
                                <b>{parse(o.name)}</b>
                                {(o.input === true && d[i.id] === o.id) &&
                                    <InputMask key={`input_${o.id}`} id={`input_${o.id}`} name={`input_${o.id}`}
                                        type="text" value={d && d[o.id]} autoComplete="off"
                                        placeholder={o.placeholder}
                                        onChange={(event) => setValue(o.id, event.target.value)}
                                        className={i.error ? 'border-danger' : ''} />
                                }
                            </label>
                        ))}
                    </div>
                );
            case "listCheck":
                return (
                    <div key={i.id} id={i.id} className="d-flex div-radio">
                        {i.options?.map((o) => (
                            <label key={o.id} className="label-input label-radio d-flex">
                                <input id={o.id} className="radioInput" type="checkbox" name={i.id}
                                    checked={d && d[i.id]?.includes(o.id)}
                                    onChange={(event) => setValue(i.id, event.target.id,true)} />
                                <b>{parse(o.name)}</b>
                                {(o.input === true && d[i.id]?.includes(o.id)) &&
                                    <InputMask key={`input_${o.id}`} id={`input_${o.id}`} name={`input_${o.id}`}
                                        type="text" value={d && d[o.id]} autoComplete="off"
                                        placeholder={o.placeholder}
                                        onChange={(event) => setValue(`${i.id}_${o.id}_desc`, event.target.value)}
                                        className={i.error ? 'border-danger' : ''} />
                                }
                            </label>
                        ))}
                    </div>
                );
            case "hr":
                return (<hr key={i.id} />);
            default:
                return (<div key={i.id} className={`div-input ${i.class}`}></div>);
        }
    };

     return(
        <div className="basePage">
            <h4 className="title">Formulário Clínico para Estudo de Risco Hereditário de Câncer</h4>
            <form key="form2" id="form2" onSubmit={handleSubmit}>
                <div className="row g-0">
                    { items.map((i)=>{
                        if(!("show" in i) || i.show.every((s) => currentData[s.key] === s.value)) {
                            return(
                                <div key={i.id} className={`div-input ${i.class}`}>
                                    {i.text != '' && <label htmlFor={i.id} className="label-input">{i.text}</label>}
                                    <div className="input-page-1" style={{"width": "100%"}}>
                                        {getItem(i,currentData)}
                                        {i.error && <span className="error-text">{i.error}</span>}
                                    </div>
                                </div>)
                        }
                    })}
                    {currentData['sem_historia_familiar_de_cancer'] !== true &&
                        <div  className={`div-input col-xs-12 col-lg-12 table-history`}>
                             <div className="row g-0">
                                { items2.map((i)=>
                                    <b className={`header-items ${i.class}`}>{i.text}</b>
                                    )
                               }
                            </div>
                            {currentData.cancer_family_items.map((c)=>
                                <div className="row g-0">
                                    { items2.map((i)=> {
                                        var newI = {...i,id:`${i.id}${c.id}`}
                                        return(
                                            <div key={newI.id} className={`div-input ${newI.class}`}>
                                                {getItem(newI, currentData)}
                                            </div>
                                        )
                                    })}
                                </div>
                                )}
                            {
                                currentData.cancer_family_items.length < 5 &&
                                    <button className="btn-blue btn-m" type="button" onClick={addNewLine}>
                                        Adicionar outra linha +
                                    </button>
                            }
                        </div>
                    }
                </div>

            </form>
            <br/>
        </div>
    );
}